export const headers = {
    initialHeaders: [
      { title: "Tipo de Contrato", field: "contractTypeDescription", child: null },
      { title: "Estado", field: "status", child: null },

    
    ],
  };

  export const defaultSearchValues = {
    contractType: null,
    status: null,
  };

  export const defaultValues = {
    contractType: null,
    status: "Inactivo",
    headerInformation: "",
  };

  export const defaultValuesFormat = {
    name: null,
    status: "",
  };